import React, {PureComponent} from 'react';
import toastr from 'toastr';
import {getCurrentUserId, getJwt, setCurrentUserName} from "../../../services/authService";
import http from "../../../services/httpService";
import Input from '../../common/Input';
import InputRegular from '../../common/InputRegular';
import ChangeEmailModal from "../../modals/ChangeEmailModal";
import InviteAdminsModal from "../../modals/InviteAdminsModal";
import VerifyNumberModal from '../../modals/VerifyNumberModal';

import {FileUploadVaporNaked} from '../FileUploadVaporNaked';

class PersonalInfo extends PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            changeEmailModalVisible: false,
            spinnerActive: false,
            user: this.props.user,
            emailDisabled: true,
            oldEmail: this.props.user.email,
            loadingEmail: false,
            selectedFile: null,
            selectedFileData: null,
            loaded: 0,
            message: '',
            profile_photo: props.profile_photo !== null ? props.profile_photo : "/img/default-user.jpg",
            oldProfilePhoto: '',
            data: {
                email: this.props.message ? this.props.message.email : this.props.user.email,
                name: this.props.message ? this.props.message.name : this.props.user.name,
                first_name: this.props.message ? this.props.message.first_name : this.props.user.name.split(' ')[0],
                last_name: this.props.message ? this.props.message.last_name : this.props.user.name.split(' ')[1],
                organization: "",
                phone: this.props.user && this.props.user.phone ? this.props.user.phone : '',
                country: this.props.user && this.props.user.country ? this.props.user.country : ''
            },
            nothingChanged: true,
            errors: {},
            fieldsCheckActive: false,
            errorsList: [],
            modalSpinnerActive: false,
            dataOnMount: {
                email: this.props.message ? this.props.message.email : this.props.user.email,
                name: this.props.message ? this.props.message.name : this.props.user.name,
                first_name: this.props.message ? this.props.message.first_name : this.props.user.name.split(' ')[0],
                last_name: this.props.message ? this.props.message.last_name : this.props.user.name.split(' ')[1],
                organization: ""
            },
            verifyNumberModalActive: false
        };
        this.clickCancel = this.clickCancel.bind(this);
    }

    handleModal = async () => {
        await this.setState({changeEmailModalVisible: false})
    }

    changeEmail = async (newEmail, oldEmail) => {
        await this.setState({modalSpinnerActive: true})
        let oldData = this.state.data
        let userId = this.state.user.id
        let name = this.state.dataOnMount.name
        let firstName = this.state.dataOnMount.first_name
        let lastName = this.state.dataOnMount.last_name

        let data = {
            email: oldEmail,
            new_email: newEmail
        }
        try {
            const result = await http.patch('api/user/' + userId + '/email', data, {headers: {authorization: getJwt()}});

            toastr.success('Your new email is ' + result.data.data.email);
            this.setState({
                user: Object.assign(
                    {},
                    this.state.user,
                    {
                        email: result.data.data.email,
                        oldEmail: result.data.data.email,
                        name,
                        first_name: firstName,
                        last_name: lastName
                    }
                )
            });
            this.setState({
                data: {
                    email: newEmail,
                    oldEmail: result.data.data.email,
                    name: oldData.name,
                    first_name: oldData.first_name,
                    last_name: oldData.last_name,

                }
            })

        } catch (e) {
            toastr.error('Error Code #15044: That email is already in use! Please try with different email.');
            this.setState({
                    data: {
                        email: oldEmail,
                        oldEmail: oldEmail,
                        name: oldData.name,
                        first_name: oldData.first_name,
                        last_name: oldData.last_name,
                    }
                }
            )

        }
        this.setState({
            modalSpinnerActive: false,
            changeEmailModalVisible: false
        })
    }

    clickCancel() {
        // console.log('cancel clicked')
        this.fileInput.value = "";
        let oldProfilePhoto = this.state.oldProfilePhoto;
        this.setState({
            data: {
                email: this.props.message ? this.props.message.email : this.props.user.email,
                name: this.props.message ? this.props.message.name : this.props.user.name,
                first_name: this.props.message ? this.props.message.first_name : this.props.user.name.split(' ')[0],
                last_name: this.props.message ? this.props.message.last_name : this.props.user.name.split(' ')[1],
                organization: "",

            },
            profile_photo: oldProfilePhoto,
            selectedFileData: oldProfilePhoto,
            nothingChanged: true
        })
    }


    redirect() {
        this.setState({spinnerActive: false});
        this.props.parentMethod();
    }

    doSubmit = async () => {
        await this.saveData(this.state.data);
        await this.setState({
            nothingChanged: true
        });
        setCurrentUserName(this.state.data.name)
    };

    componentDidUpdate = async () => {
        if (this.props.user !== this.state.user) {
            await this.setState({
                data: {
                    email: this.props.user.email,
                    name: this.props.user.name,
                    first_name: this.props.user.name.split(' ')[0],
                    last_name: this.props.user.name.split(' ')[1],
                    organization: ""
                },
                user: this.props.user,
                selectedFileData: this.props.user.profile_photo
            })
        }
    }

    saveData = async (formProps) => {
        // console.log('saveData entered')
        await this.setState({fieldsCheckActive: true})
        let anyErrorActive = false;
        await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
        if (!anyErrorActive) {
            await this.setState({spinnerActive: true})
        }
        setTimeout(async () => {
            if (!anyErrorActive) {
                //console.log('no active errors')


                let formPropsReduced = {};
                formPropsReduced.id = formProps.id;
                formPropsReduced.user_id = formProps.id;
                formPropsReduced.first_name = formProps.first_name;
                formPropsReduced.last_name = formProps.last_name;
                formPropsReduced.organization = '';
                formPropsReduced.profile_photo = this.state.profile_photo;
                try {
                    //console.log('formPropsReduced: ', formPropsReduced)
                    const result = await http.patch('api/user/' + this.state.user.id, formPropsReduced, {
                        headers: {
                            authorization: getJwt()
                        }
                    });
                    //console.log("saveData result.data", result.data);

                    const data = result.data.data;
                    let firstName = this.state.data.first_name
                    let lastName = this.state.data.last_name
                    let fullName = this.state.data.first_name + ' ' + this.state.data.last_name
                    await this.props.changeMessageData(firstName, lastName, fullName)
                    await this.setState({
                        message: data,
                        spinnerActive: false,
                        dataOnMount: {
                            email: this.state.data.email,

                            first_name: firstName,
                            last_name: lastName,
                            name: fullName,
                            organization: ""
                        }
                    });


                    //this.props.parentMethod(formProps);
                    if(this.state.profile_photo){
                        this.props.updatePhoto(this.state.profile_photo);
                    }
                    toastr.success('Your personal info has been updated successfully!')
                } catch (e) {
                    this.setState({spinnerActive: false});
                    toastr.error('Error Code #15045: Something went wrong with updating your personal info... Please try again.')
                }
            } else {
                toastr.error('Error Code #15046: Please check errors!')
                this.setState({spinnerActive: false});
            }
        }, 500)
    }


    fileSelectedUploadHandler = (selectedFile) => {
        const reader = new FileReader();
        reader.addEventListener(
            'load',
            () =>
                this.setState({
                    selectedFileData: reader.result
                }),
            false
        );

        reader.readAsDataURL(selectedFile.target.files[0]);

        this.setState({
            selectedFile: selectedFile.target.files[0]
        });

        if (selectedFile.target.files[0]) {
            let formData = {
                file: selectedFile.target.files[0],
                category: "profile_photo",
                name: selectedFile.target.files[0].name,
                size: selectedFile.target.files[0].size,
                type: selectedFile.target.files[0].type
            };

            FileUploadVaporNaked(formData, this.onUploadStart, this.onUploadProgressChange, this.onUploadEnd, this.onUploadError)

        }

    };
    handleChanged = () => {
        // console.log('input changed')
        this.setState({
            nothingChanged: false
        })
    };

    onUploadStart = () => {
        this.setState({
            oldProfilePhoto: this.state.profile_photo
        });
    }

    onUploadProgressChange = (progress) => {
        this.setState({loaded: Math.round(progress * 100)});
        // console.log('onUploadProgressChange: ', progress, this.state.loaded)
    }

    onUploadEnd = (url) => {
        // console.log('onUploadEnd: ', url)
        // toastr.success("Profile image successfully saved!");
        // //setTimeout(() => {
        this.setState({
            loaded: 0,
            profile_photo: url,
            //profile_photo: "/img/jon-snow-glasses.jpg",
            selectedFile: null,
            selectedFileData: null,
            spinnerActive: false,
            nothingChanged: false
        });
    }

    onUploadError = () => {
        this.setState({
            loaded: 0,
            spinnerActive: false
        });
    }

    addDefaultSrc = (ev) => {
        ev.target.src = '/img/default-user.jpg';
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    // golubTest = async () => {
    //     try{
    //         const result = await http.post('api/test', {}, {headers: {authorization: getJwt()}});
    //         console.log('Golub test result: ', result)
    //     }catch(e){
    //         console.log('Greska: ', e)
    //     }
    // }


    render() {
        return (
            <React.Fragment>
                <div className='panel-container profile-tab'>

                    <h3>Personal Info</h3>
                    <div className="flex-row profile-picture-container">
                        <div className="profile-pic-container text-center">
                            {this.state.selectedFileData ?
                                <img src={this.state.selectedFileData} alt="User Profile Pic"
                                     onError={this.addDefaultSrc}
                                     className="profile-picture"/> :
                                (this.state.profile_photo ?
                                        <img src={this.state.profile_photo} alt="User Profile Pic"
                                             onError={this.addDefaultSrc}
                                             className="profile-picture"/>
                                        :
                                        <img src='/img/default-user.jpg' alt="User Profile Pic"
                                             onError={this.addDefaultSrc}
                                             className="profile-picture"/>
                                )

                            }
                        </div>
                        <div className="sync-buttons text-center">
                            <input style={{display: "none"}}
                                   type="file"
                                   onChange={this.fileSelectedUploadHandler}
                                   ref={fileInput => this.fileInput = fileInput}/>

                            {
                                this.state.loaded > 0 ?
                                    <button className="btn-action btn-spinner" disabled={true}>Upload <i className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button onClick={() => this.fileInput.click()} className="btn-action">Upload</button>
                            }
                        </div>
                    </div>

                    <div className="form-group input-error-container">
                        <InputRegular
                            id="1"
                            label1="First Name"
                            label2=""
                            placeholder=""
                            type='text'
                            onChange={(value) => this.setState({
                                data: {
                                    ...this.state.data,
                                    first_name: value,
                                },
                                nothingChanged: false
                            })}
                            value={this.state.data.first_name}
                            required={true}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="First Name can't be empty"
                        />

                    </div>
                    <div className="form-group input-error-container">
                        <InputRegular
                            id="2"
                            label1="Last Name"
                            label2=""
                            placeholder=""
                            type='text'
                            onChange={(value) => this.setState({
                                data: {
                                    ...this.state.data,
                                    last_name: value,

                                },
                                nothingChanged: false
                            })}
                            value={this.state.data.last_name}
                            required={true}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="Last Name can't be empty"
                        />
                    </div>
                    <div className="flex-row space-between profile-email-change-container margin-bottom-10">
                        <div className="form-group">
                            <label htmlFor="last_name">Email</label>
                            <Input disabled={true} value={this.state.data.email}/>
                        </div>
                        <a

                            id="email_btn"
                            data-toggle="modal"
                            data-target="#emailModal"
                            onClick={() => this.setState({changeEmailModalVisible: true})}
                        >
                            Change
                        </a>
                    </div>

                    <div className="flex-row space-between profile-email-change-container m-xl-b">
                        <div className="form-group">
                            <label htmlFor="last_name">Phone</label>
                            <Input disabled={true} value={this.props.user.phone}/>
                        </div>
                        <a

                            id="email_btn"
                            data-toggle="modal"
                            data-target="#emailModal"
                            onClick={() => this.setState({verifyNumberModalActive: true})}
                        >
                            Change
                        </a>
                    </div>

                    {/*<button onClick={this.golubTest}>Golub provera</button>*/}

                    <div className="edit-profile-tab-buttons">

                        <button
                            disabled={this.state.nothingChanged}
                            className="btn-white-border"
                            onClick={this.clickCancel}
                            type="button">
                            Cancel
                        </button>

                        <button
                            id="save"
                            disabled={this.state.spinnerActive || this.state.nothingChanged}
                            className="btn-action"
                            onClick={this.doSubmit}
                        >
                            {
                                this.state.spinnerActive ?
                                    <React.Fragment>
                                        Save
                                        <i className='fa fa-spin fa-spinner'></i>
                                    </React.Fragment>
                                    :
                                    'Save'
                            }

                        </button>
                    </div>

                </div>
                <ChangeEmailModal

                    showModal={this.state.changeEmailModalVisible}
                    modalSpinnerActive={this.state.modalSpinnerActive}
                    oldEmail={this.state.data.email}
                    width={500}
                    changeEmail={this.changeEmail}
                    handleClose={this.handleModal}
                    history={this.props.history}

                />
                <VerifyNumberModal
                    showModal={this.state.verifyNumberModalActive}
                    handleClose={() => this.setState({verifyNumberModalActive: false, existingNumberData: ''})}
                    selectedSource={this.props.selectedSource}
                    maxWidth={600}
                    history={this.props.history}
                    user={this.props.user}
                    updateUserFromServer={this.props.updateUserFromServer}
                    handleGetNumbers={this.getNumbers}
                    existingNumberData={{
                        phone_number: this.props.user.phone,
                        country_iso: this.props.user.country
                    }}
                    editMainPhoneNumber={true}
                />
            </React.Fragment>
        )
    }
}

export default PersonalInfo;